import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const _style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  width: '75%',
  '@media screen and (max-width:1000px)': {
    width: '100%'
  },
  p: 4
};
const FormModal = ({
  children,
  sx,
  Form,
  onSubmit,
  FormAttrs,
  title
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const _onSubmit = async e => {
    if (onSubmit) {
      await onSubmit(e);
    }
    handleClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    onClick: handleOpen,
    sx: {
      width: '100%',
      ...sx
    }
  }, children), /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "modal-modal-title",
    "aria-describedby": "modal-modal-description"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: _style
  }, /*#__PURE__*/React.createElement(Typography, {
    id: "modal-modal-title",
    variant: "h6",
    component: "h2"
  }, title), /*#__PURE__*/React.createElement(Box, {
    sx: {
      mt: 2
    }
  }, Form && Form({
    ...FormAttrs,
    onSubmit: _onSubmit
  })))));
};

export { FormModal };
